import React from "react";

export const IconCheck = ({ fill = "#1C2D3B", className = "", style = {} }) => {
  return (
    <svg className={` ${className}`} fill="none" height="16" viewBox="0 0 16 16" width="16" style={style}>
      <path
        className="path"
        d="M5.71429 14L0 8.24184L1.61143 6.61804L5.71429 10.7409L14.3886 2L16 3.63532L5.71429 14Z"
        fill={fill}
      />
    </svg>
  );
};
